var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user--follow_svg__clip0_61530_7446)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 10.5h-3v-3h-1.5v3h-3V12h3v3H21v-3h3v-1.5zM9 3a3.75 3.75 0 110 7.5A3.75 3.75 0 019 3zm0-1.5A5.25 5.25 0 109 12 5.25 5.25 0 009 1.5zM16.5 22.5H15v-3.75A3.75 3.75 0 0011.25 15h-4.5A3.75 3.75 0 003 18.75v3.75H1.5v-3.75a5.25 5.25 0 015.25-5.25h4.5a5.25 5.25 0 015.25 5.25v3.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user--follow_svg__clip0_61530_7446"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgUserFollow;